import React, { useEffect } from 'react';
import * as Yup from 'yup';
import { useLocation, useNavigate } from 'react-router-dom';

import Loader from '../../components/loader/Loader';
import { FONT_FAMILY, MODAL_BORDER_RADIUS } from '../../components/constants/style-constants';

import LinksChallengeForm from '../../components/challenge/LinksChallengeForm';
import { getValidationSchema, getInitialValues } from '../../helpers/form-helper';

import { useTemplate, setParameters } from '../../store/TemplateContext';
import { fetchNext, useLinks } from '../../store/LinksContext';
// import { toAbsoluteUrl } from '../../helpers/AssetHelpers';

import './Links.css';
import { toAbsoluteUrl } from '../../helpers/AssetHelpers';
import { setSentryTags } from '../../helpers/sentryHelper';

export const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const executeRecaptcha = (): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.grecaptcha.ready(() => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.grecaptcha
        .execute(SITE_KEY, { action: 'submit' })
        .then((token: any) => {
          resolve(token);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  });
};

interface Props {}

export interface IValidationRules {
  [key: string]: {
    value: string;
    params: null | (string | ((value: string) => void))[];
  }[];
}

export interface IInitialValues {
  values: { [key: string]: string };
  validation: IValidationRules;
}

const spreedlyValidationSchema = Yup.object().shape({
  full_name: Yup.string().required('Full name is required'),
  month: Yup.string().required('Month is required'),
  year: Yup.string().required('Year is required'),
});

const spreedlyInitialValues = {
  full_name: '',
  month: '',
  year: '',
};

const Links: React.FC<Props> = props => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(search);
  const id = searchParams.get('id');

  const {
    state: { links, isLinksLoading },
    dispatch: commonDispatch,
  } = useLinks();
  const { dispatch } = useTemplate();

  useEffect(() => {
    setSentryTags({ linkId: id });
    if (id) {
      fetchNext(commonDispatch, id, navigate);

      return () => hideRecaptcha();
    }
  }, []);

  useEffect(() => {
    setParameters(dispatch, links?.parameters || {});
  }, [
    links?.parameters?.CureType,
    links?.parameters?.PaymentInstrumentToken,
    links?.parameters?.CardBrand,
    links?.parameters?.CardLast4Digits,
    links?.parameters?.TokenField,
    links?.parameters?.FirstNameField,
    links?.parameters?.AcsURL,
    links?.parameters?.EncodedCReq,
    links?.parameters?.ThreeDSSessionData,
    links?.parameters?.Token,
  ]);

  const showRecaptchaBadge = (): void => {
    const script = document.querySelector('.grecaptcha-badge');
    if (script) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      script.style.visibility = 'visible';
    }
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    document.body.appendChild(script);
    showRecaptchaBadge();
  }, []);

  const hideRecaptcha = (): void => {
    const script = document.querySelector('.grecaptcha-badge');
    if (script) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      script.style.visibility = 'hidden';
    }
  };

  if (
    // checkIfPlaidTemplate(template?.challenge) ||
    isLinksLoading ||
    !links?.challenge
  ) {
    return <Loader />;
  }

  // if (parameters?.AcsURL) {
  //   return <Tokenex3DS />;
  // }

  const initialValues = getInitialValues({ values: {}, validation: {} }, links?.challenge, false);

  const getSpreedlyInitialValues = (): { [key: string]: string } => {
    const values = { ...spreedlyInitialValues };

    if (links?.parameters?.ExpirationMonth) {
      values.month = links?.parameters?.ExpirationMonth;
    }

    if (links?.parameters?.ExpirationYear) {
      values.year = links?.parameters?.ExpirationYear;
    }

    if (links?.parameters?.HolderName) {
      values.full_name = links?.parameters?.HolderName;
    }

    return values;
  };

  return (
    <div className="links">
      {/*<img alt="Logo" className="links-logo" src={toAbsoluteUrl('/flex-logo-small.svg')} />*/}
      <LinksChallengeForm
        isCard={false}
        template={links?.challenge}
        initialValues={initialValues.values}
        validationSchema={getValidationSchema(initialValues.validation)}
        spreedlyValidationSchema={spreedlyValidationSchema}
        spreedlyInitialValues={getSpreedlyInitialValues()}
      />
    </div>
  );
};

export default Links;
